<template>
  <div class="navi" style="background-color: transparent">
    <div class="navigation_bar">
      <div :class="[darkMode ? 'dark' : 'light', 'navigation-root']">
        <div class="status" style="height: 36px"></div>

        <div class="main">
          <div class="container">
            <div class="single-back" @click="back">
              <div class="tidy-image" >
                <img
                  :src="darkMode ? 'https://ops-1300522992.cos.ap-guangzhou.myqcloud.com/doc/YZ/images/groupV2/icon-back-dark.png' : 'https://ops-1300522992.cos.ap-guangzhou.myqcloud.com/doc/YZ/images/groupV2/icon-back-light.png'"
                  draggable="true"
                  style="width: 100%; height: 100%"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jsBridge from '@/utils/jsBridge';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    darkMode: {
      type: Boolean,
      value: false,
    },
  },
  methods: {
    back() {
      jsBridge.ares.goBack();
    },
  },
};
</script>
<style scoped>
.navi {
  z-index: 999;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.navigation-root {
  width: 100%;
  position: relative;
  text-align: center;
}

.navigation-root .main {
  display: flex;
  align-items: stretch;
  height: 3.142857142857143rem;
}

.background {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
}

.navigation-root .container {
  display: flex;
  margin-left: 0.8571428571428571rem;
  position: relative;
  z-index: 10;
  max-height: 2.2857142857142856rem;
}

.navigation-root.dark .container {
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(151, 151, 151, 0.2);
  border-radius: 45%;
}

.navigation-root.light .container {
  background: rgba(255, 255, 255, 0.60);
  border: 1px solid rgba(151, 151, 151, 0.2);
  border-radius: 45%;
}

.navigation-root .main .single-back {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0.6428571428571429rem;
  padding-left: 0.6428571428571429rem;
  margin: 0.5rem 0;
}

.navigation-root.dark .main .single-back {
  border-color: rgba(255, 255, 255, 0.25);
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
}

.navigation-root .main .single-back .tidy-image {
  width: 1.4285714285714286rem;
  height: 1.4285714285714286rem;
}

.navigation-root .main .right {
  margin: 0.5rem 0;
  padding-left: 0.6428571428571429rem;
  line-height: 1.4285714285714286rem;
  padding-right: 0.7142857142857143rem;
  display: flex;
  align-items: center;
  border-left: 0.03571428571428571rem solid rgba(0, 0, 0, 0.2);
}

.navigation-root .main .right .menu {
  height: 1.4285714285714286rem;
}

.navigation-root .main .page-name {
  flex: 1;
  color: #333333;
  height: 3.142857142857143rem;
}

.navigation-root.dark .main .page-name {
  color: #ffffff;
}

.navigation-root .main .page-name.page-center {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
